export class DateHelper {

    static _DECIMAL = ',';
    static _MILHAR = '.';

    static toDateHourFixed(date: Date) {
        var dateReturn = date.toISOString().replace(/T\d{2}:\d{2}:\d{2}\.\d+Z/, 'T12:00:00.000');
        return new Date(dateReturn);
    }
}